import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableLabelsComponent from '../components/TableLabelsComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

// (Se llamaba `LoginPage` por copiar/pegar del molde; el nombre no se ve en ningún lado porque
// se exporta como default, pero confundía a cualquiera que abriera el archivo.)
class LabelsPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
    }

    async componentDidMount() {
        let role = await validateSession(true)
        this.setState({ checked: true, role: role });
    }

    addCollection = () => {
        navigateTo('/addLabel');
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={15} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="Etiquetas" subtitle="Colecciones de la home"/>
                                <p style={{ color: '#818ea3', marginTop: '-1rem' }}>
                                    Son las secciones curadas de la home de la tienda: el carrusel de arriba y los
                                    recuadros de categoría. Vos elegís qué productos van en cada una y cuándo se publican.
                                </p>
                                <TableLabelsComponent />
                            </div>
                        </main>
                    </div>
                    <div onClick={() => this.addCollection()} className="color-switcher-toggle animated pulse infinite" title="Nueva colección">
                        <i className="material-icons">add</i>
                    </div>
                </div>
            );
        }
    }
}

export default LabelsPage;
